<template>
    <select v-model="claimStatus">
        <option :value="null">All Claims</option>
        <option value="active">Live</option>
        <option value="closed">Concluded</option>
        <!-- <option value="individual">Individual Claim</option> -->
    </select>
</template>

<script>
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import Control from 'components/form/Control.vue';

    export default {
        name: 'claim-status',
        components: {
            Control,
        },
        computed: {
            ...mapState('discountRateComparison', {
                getClaimStatus: 'claimStatus',
            }),
            ...mapGetters('discountRateComparison', {
                individualClaim: 'individualClaim',
            }),
            claimStatus: {
                get() {
                    return this.getClaimStatus;
                },
                set(value) {
                    this.update({ key: 'claimStatus', value });
                },
            },
        },
        methods: {
            ...mapActions('discountRateComparison', [
                'update',
            ]),
        }
    }
</script>



// WEBPACK FOOTER //
// ClaimStatus.vue?1fbacb53